// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlockServices_root__lnCDb","title":"PricingBlockServices_title__qJysL","included":"PricingBlockServices_included__ynS8e"};